<template>

    <div>

        <lottie
            :height="85"
            :options="defaultOptions"
            v-on:animCreated="handleAnimation"
        />

    </div>

</template>

<script>

import Lottie from 'vue-lottie'

import * as animationData from '../../../public/img/lottie/ctaCard/delete.json'

export default {

    name: 'lottie-cta-card-delete',

    components: {Lottie},

    props: {
        active: {
            type: Boolean,
            default: false
        }
    },

    watch: {
        active: function (play) {
            if(play) {
                this.play()
            } else {
                this.stop()
            }
        }
    },

    data() {
        return {
            defaultOptions: {
                animationData: animationData.default,
                loop: false,
                autoplay: false

            },
            anim: null
        }
    },

    methods: {

        handleAnimation: function (anim) {
            this.anim = anim
        },

        stop: function () {
            this.anim.stop()
        },

        play: function () {
            this.anim.play()
        },

        pause: function () {
            this.anim.pause()
        },

        onSpeedChange: function () {
            this.anim.setSpeed(this.animationSpeed)
        }
    }

}

</script>

<style lang="scss" scoped></style>
